import { BooleanInput, coerceBooleanProperty } from "@angular/cdk/coercion";
import { ChangeDetectionStrategy, Component, Input } from "@angular/core";
import { LocalComponentStore } from "@dtm-frontend/shared/utils";

interface InfoComponentState {
    headerText: string | undefined;
    linkText: string | undefined;
    link: string | undefined;
    route: string | undefined;
    isDownload: boolean;
}

@Component({
    selector: "dtm-main-page-lib-info",
    templateUrl: "./info.component.html",
    styleUrls: ["./info.component.scss"],
    changeDetection: ChangeDetectionStrategy.OnPush,
    providers: [LocalComponentStore],
})
export class InfoComponent {
    @Input() public set headerText(value: string | undefined) {
        this.localStore.patchState({ headerText: value });
    }
    @Input() public set linkText(value: string | undefined) {
        this.localStore.patchState({ linkText: value });
    }
    @Input() public set link(value: string | undefined) {
        this.localStore.patchState({ link: value });
    }
    @Input() public set route(value: string | undefined) {
        this.localStore.patchState({ route: value });
    }
    @Input() public set isDownload(value: BooleanInput) {
        this.localStore.patchState({ isDownload: coerceBooleanProperty(value) });
    }

    protected readonly headerText$ = this.localStore.selectByKey("headerText");
    protected readonly linkText$ = this.localStore.selectByKey("linkText");
    protected readonly link$ = this.localStore.selectByKey("link");
    protected readonly route$ = this.localStore.selectByKey("route");
    protected readonly isDownload$ = this.localStore.selectByKey("isDownload");

    constructor(private readonly localStore: LocalComponentStore<InfoComponentState>) {
        this.localStore.setState({
            headerText: undefined,
            linkText: undefined,
            link: undefined,
            isDownload: false,
            route: undefined,
        });
    }
}
